import { COLORS } from '@btime/constants'
import React from 'react'

import { sideMenuWidth } from '../navigation/SideMenu'
import MainMenu from '../../modules/menu/mainMenu/MainMenu'
import ExpiredContractMessage from '../messenger/ExpiredContractMessage'
import PendingBillingMessage from '../messenger/PendingBillingMessage'
import ProcessesFeatureMessage from '../messenger/ProcessesFeatureMessage'

// TODO: Change name for AbsoluteWithSpacePageTemplate
const AbsoluteWithMenuSpacePageTemplate = ({ children, bgColor }) => {
  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 999,
        top: 0,
        left: 0,
        paddingLeft: `${sideMenuWidth}rem`,
        right: 0,
        bottom: 0,
        overflow: 'scroll',
        minHeight: '100vh',
        backgroundColor: bgColor || COLORS.light1
      }}
    >
      <div
        style={{
          position: 'relative'
        }}
      >
        <ExpiredContractMessage />
        <PendingBillingMessage />
        <ProcessesFeatureMessage />
        {children}
      </div>
      <MainMenu />
    </div>
  )
}

export default AbsoluteWithMenuSpacePageTemplate
